import { z } from "zod";

const EnvSchema = z.object({
  apiUrl: z.string().refine(
    (value) => value.startsWith("/") || /^https?:\/\//.test(value),
    "apiUrl must be an absolute URL or same-origin path"
  ),
  appEnv: z.string().default(import.meta.env.MODE ?? "development"),
  googleClientId: z.string().optional(),
  sentryDsn: z.string().url().optional(),
  release: z.string().optional()
});

export function getWebEnv() {
  const appEnv = import.meta.env.VITE_APP_ENV ?? import.meta.env.MODE ?? "development";
  const apiUrl = import.meta.env.VITE_API_URL;
  
  // Determine API URL with fallback chain
  let finalApiUrl = apiUrl;
  
  if (!finalApiUrl) {
    if (appEnv === "production") {
      console.warn("⚠️ VITE_API_URL not set, using same-origin /api proxy in production");
      // Use same-origin proxy through Vercel rewrites so the browser never hits Railway directly.
      finalApiUrl = "/api";
    } else {
      console.warn("⚠️ VITE_API_URL not set, using localhost:8080 (development only)");
      finalApiUrl = "http://localhost:8080";
    }
  }

  if (appEnv === "production" && finalApiUrl === "https://homeapi-production.up.railway.app") {
    console.warn("⚠️ Normalizing production Railway URL to same-origin /api proxy");
    finalApiUrl = "/api";
  }
  
  return EnvSchema.parse({
    apiUrl: finalApiUrl,
    appEnv,
    googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID,
    sentryDsn: import.meta.env.VITE_SENTRY_DSN,
    release:
      import.meta.env.VITE_RELEASE ||
      import.meta.env.VERCEL_GIT_COMMIT_SHA ||
      import.meta.env.RAILWAY_GIT_COMMIT_SHA
  });
}
